export const projectsTranslations: Record<string, { title: string; subtitle: string }> = {
  pt: {
    title: "Projetos",
    subtitle: "Acompanhe despesas de projetos e associe transações",
  },
  en: {
    title: "Projects",
    subtitle: "Track project expenses and associate transactions",
  },
  es: {
    title: "Proyectos",
    subtitle: "Supervisa gastos de proyectos y asocia transacciones",
  },
  et: {
    title: "Projektid",
    subtitle: "Jälgi projektide kulusid ja seosta tehinguid",
  },
  de: {
    title: "Projekte",
    subtitle: "Projektkosten verfolgen und Transaktionen zuordnen",
  },
  fr: {
    title: "Projets",
    subtitle: "Suivez les dépenses de projet et associez des transactions",
  },
  it: {
    title: "Progetti",
    subtitle: "Monitora le spese dei progetti e associa le transazioni",
  },
  nl: {
    title: "Projecten",
    subtitle: "Volg projectuitgaven en koppel transacties",
  },
  sv: {
    title: "Projekt",
    subtitle: "Följ projektutgifter och koppla transaktioner",
  },
  da: {
    title: "Projekter",
    subtitle: "Følg projektudgifter og tilknyt transaktioner",
  },
  fi: {
    title: "Projektit",
    subtitle: "Seuraa projektikuluja ja yhdistä tapahtumat",
  },
};
